import { ConnectTransportOptions } from '@bufbuild/connect-web';
import {
  lmsTransportWithLogoutHandler,
  ResponseStatusCodeFunction,
} from './transports';
import { createPromiseClient } from '@bufbuild/connect';
import { LLMEvaluatorServiceV1 } from '@protos/learning_management/lms.assessment.llm.apis_connect';

export const useLLMEvaluatorServiceV1ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LLMEvaluatorServiceV1,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
